import {useEffect} from 'react';

export default function useDocumentTitle (title: string){
	useEffect(() => {
		if (window.document) {
			window.document.title = title;
		}
	}, [title]);
}
